module.exports = __webpack_public_path__ + "465406c58b44567ec867643f922521bb.svg";